export default __webpack_public_path__ + "static/media/waveoflife.20461692.png";